export default "__VITE_ASSET__DRaUzEFp__"